import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AxiosService from "../../utils/AxiosService";
import localStorageService from "../../utils/auth_service/AuthServiceStorage";
import * as XLSX from "xlsx";
import Select, { SingleValue } from "react-select";

const progressReportHeader = [
  "TOTAL_UNIQUE_PROCESSED",
  "TOTAL_FP_SP",
  "TOTAL_FP_SP_UNIQUE",
  "TOTAL_RESOLVED_UNIQUE",
  "TOTAL_UNRESOLVED",
  "TOTAL_UNRESOLVED_UNIQUE",
  "NO_ACTION",
  "NO_ACTION_UNIQUE",
];

const UpdateManuscriptStatus = ({ projectId }) => {
  const [projectReport, setprojectReport] = useState([]);
  const [project, setProject] = useState("");
  const [projects, setProjects] = useState([]);
  const [llmAuthorScores, setllmAuthorScores] = useState([]);
  const [llmTitleScores, setllmTitleScores] = useState([]);
  const [projectStatusReport, setprojectStatusReport] = useState([]);
  const [doiFilters, setdoiFilters] = useState([]);
  const [selectedDoiFilter, setSelectedDoiFilter] = useState("");
  const [selectedAction, setSelectedAction] = useState();
  const [doiFilterRepoort, setDoiFilterReport] = useState([]);
  const [journalFilters, setjournalFilters] = useState([]);
  const [selectedJournalFilters, setselectedJournalFilters] = useState("");
  const [dioFlagStatusVlaue, setDioFlagStatusVlaue] = useState("");
  const [JournalReport, settJournalReport] = useState("");
  const [jorunalReportCount, setJournalReportCount] = useState("");
  const [isJournalReportLoading, setIsJournalReportLoading] = useState(false);

  useEffect(() => {
    setprojectReport(projectStatusReport);
  }, [projectStatusReport]);

  useEffect(() => {
    apiService
      .getProjectList()
      .then((response) => {
        setProjects(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  }, []);

  useEffect(() => {
    if (project !== "") {
      apiService
        .getDistinctLlmTitleScores(project)
        .then((response) => {
          setllmTitleScores(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });

      apiService
        .getDistinctLlmAuthourScores(project)
        .then((response) => {
          setllmAuthorScores(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
      apiService
        .getProjectStatusReport(project)
        .then((response) => {
          setprojectStatusReport(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });

      apiService
        .getAllDoiFilters()
        .then((response) => {
          setdoiFilters(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
      apiService
        .getAllJournals(project)
        .then((response) => {
          const journals = response.data.data; // Assuming this is a List<String>
          const newOptionData = journals.map((item) => ({
            label: item,
            value: item,
          }));
          setjournalFilters(newOptionData);
        })
        .catch((error) => {
          toast.error(error.response.data.message, {
            autoClose: 3000,
          });
        });
    }
  }, [project]);

  const initialFormData = {
    titleScoreFromRange: "",
    titleScoreToRange: "",
    authorScoreFromRange: "",
    authorScoreToRange: "",
    statusFlag: "",
    validityFlag: "",
  };
  const apiService = new AxiosService();
  const [maxRange, setmaxRange] = useState(100);
  const [minRange, setminRange] = useState("");
  const [formData, setformData] = useState(initialFormData);

  const handleRowChange = (event) => {
    const { name, value } = event.target;
    let newValue = Number(value);

    if (newValue > maxRange || newValue < 0) {
      newValue = "";
    }

    setformData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setformData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlesubmit = (type, action) => {
    const authDetails = localStorageService.getProjectDetails();
    const projectName = JSON.parse(authDetails).projectName;
    switch (type) {
      case "titleAndAuthorScore": {
        if (
          formData.titleScoreFromRange !== "" &&
          formData.titleScoreToRange !== "" &&
          formData.authorScoreFromRange !== "" &&
          formData.authorScoreToRange !== ""
        ) {
          if (
            formData.titleScoreFromRange < 0 ||
            formData.authorScoreFromRange < 0
          ) {
            toast.warn("From value must be greater than zero", 2000);
          } else if (
            formData.titleScoreToRange > 100 ||
            formData.authorScoreToRange > 100
          ) {
            toast.warn("From value must be less than 100", 2000);
          } else if (
            formData.titleScoreFromRange >= formData.titleScoreToRange ||
            formData.authorScoreFromRange >= formData.authorScoreToRange
          ) {
            toast.warn("From value must be less than To value", 2000);
          } else {
            apiService
              .updateDoiProcessedStatusByLlmTitleAndAuthorScore(
                formData.titleScoreFromRange,
                formData.titleScoreToRange,
                formData.authorScoreFromRange,
                formData.authorScoreToRange,
                action,
                projectName
              )
              .then((response) => {
                resetForm();
                toast.success(
                  response.data.data + " record " + response.data.message,
                  2000
                );
              })
              .catch((error) => {
                var msg = action === "unresolved" ? "unresolved" : "revert";
                toast.error("Failed to " + msg, 2000);
              });
          }
        } else if (
          formData.titleScoreFromRange !== "" &&
          formData.titleScoreToRange !== ""
        ) {
          if (formData.titleScoreFromRange < 0) {
            toast.warn("From value must be greater than zero", 2000);
          } else if (formData.titleScoreToRange > 100) {
            toast.warn("From value must be less than 100", 2000);
          } else if (
            formData.titleScoreFromRange >= formData.titleScoreToRange
          ) {
            toast.warn("From value must be less than To value", 2000);
          } else {
            apiService
              .updateDoiProcessedStatusByLlmTitleScore(
                formData.titleScoreFromRange,
                formData.titleScoreToRange,
                action,
                projectName
              )
              .then((response) => {
                resetForm();
                toast.success(
                  response.data.data + " record " + response.data.message,
                  2000
                );
              })
              .catch((error) => {
                var msg = action === "unresolved" ? "unresolved" : "revert";
                toast.error("Failed to " + msg, 2000);
              });
          }
        } else if (
          formData.authorScoreFromRange !== "" &&
          formData.authorScoreToRange !== ""
        ) {
          if (formData.authorScoreFromRange < 0) {
            toast.warn("From value must be greater than zero", 2000);
          } else if (formData.authorScoreToRange > 100) {
            toast.warn("From value must be less than 100", 2000);
          } else if (
            formData.authorScoreFromRange >= formData.authorScoreToRange
          ) {
            toast.warn("From value must be less than To value", 2000);
          } else {
            apiService
              .updateDoiProcessedStatusByLlmAuthorScore(
                formData.authorScoreFromRange,
                formData.authorScoreToRange,
                action,
                projectName
              )
              .then((response) => {
                toast.success(
                  response.data.data + " record " + response.data.message,
                  2000
                );
                resetForm();
              })
              .catch((error) => {
                var msg = action === "unresolved" ? "unresolved" : "revert";
                toast.error("Failed to " + msg, 2000);
              });
          }
        } else {
          toast.warn("Please fill either Title score or Author score", 2000);
        }
        break;
      }
      case "authorAndDateFlag": {
        if (formData.statusFlag !== "" && formData.validityFlag !== "") {
          apiService
            .updateDoiProcessedStatusByAuthourAndDateFlag(
              formData.statusFlag,
              formData.validityFlag,
              action,
              projectName
            )
            .then((response) => {
              toast.success(
                response.data.data + " record " + response.data.message,
                2000
              );
              resetForm();
            })
            .catch((error) => {
              var msg = action === "unresolved" ? "unresolved" : "revert";
              toast.error("Failed to " + msg, 2000);
            });
        } else if (formData.statusFlag !== "") {
          apiService
            .updateDoiProcessedStatusByAuthorStatus(
              formData.statusFlag,
              action,
              projectName
            )
            .then((response) => {
              toast.success(
                response.data.data + " record " + response.data.message,
                2000
              );
              resetForm();
            })
            .catch((error) => {
              var msg = action === "unresolved" ? "unresolved" : "revert";
              toast.error("Failed to " + msg, 2000);
            });
        } else if (formData.validityFlag !== "") {
          apiService
            .updateDoiProcessedStatusByDateFlag(
              formData.validityFlag,
              action,
              projectName
            )
            .then((response) => {
              toast.success(
                response.data.data + " record " + response.data.message,
                2000
              );
              resetForm();
            })
            .catch((error) => {
              var msg = action === "unresolved" ? "unresolved" : "revert";
              toast.error("Failed to " + msg, 2000);
            });
        } else {
          toast.warn("Please fill either Authour flag or Date flag", 2000);
        }

        break;
      }

      default: {
        var msg = action === "unresolved" ? "unresolved" : "revert";
        toast.error("Failed to " + msg, 2000);
        break;
      }
    }
  };

  const resetForm = () => {
    setformData(initialFormData);
    apiService
      .getProjectStatusReport(project)
      .then((response) => {
        setprojectReport(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    setProject(projectId);
    const selectedProject = projects.find((project) => {
      if (project.projectId == projectId) {
        return project;
      }
    });
    localStorageService.setProjectDetails(
      JSON.stringify({
        projectId: projectId,
        projectName: selectedProject ? selectedProject.projectName : "",
      })
    );
  };

  const handleDoiFilterChange = (e) => {
    setSelectedDoiFilter(e.target.value);
  };

  const handleJournalFilterChange = (selectedOption) => {
    setselectedJournalFilters(selectedOption ? selectedOption.value : "");
  };
  const handleJournalFlagFilter = (action) => {
    if (selectedJournalFilters === "") {
      toast.error("Please Select the Filter..!!", { autoClose: 3000 });
    } else {
      const isConfirmed = window.confirm(
        `Are you sure you want to perform the ${action} action?`
      );

      if (!isConfirmed) {
        return;
      }
      const authDetails = localStorageService.getProjectDetails();
      const projectName = JSON.parse(authDetails).projectName;
      apiService
        .updateJournalFlagStatus(
          selectedJournalFilters,
          action,
          projectName
        )
        .then((response) => {
          toast.success(
            response.data.data + " record " + response.data.message,
            2000
          );
          resetForm();
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
    }
  };

  const handleDioFlagStatus = (action) => {
    if (dioFlagStatusVlaue === "") {
      toast.error("Please Enter manuscript and doi..!!", { autoClose: 3000 });
    } else {
      const isConfirmed = window.confirm(
        `Are you sure you want to perform the ${action} action?`
      );

      const entries = dioFlagStatusVlaue.split(";;");

      const invalidEntries = entries.filter((entry) => {
        const parts = entry.trim().split("@");
        return (
          parts.length !== 2 || parts[0].trim() === "" || parts[1].trim() === ""
        );
      });

      if (invalidEntries.length > 0) {
        toast.error(
          "Invalid format! Use manuscriptId@doi and separate multiple entries with ';;'.",
          { autoClose: 4000 }
        );
        return;
      }

      if (!isConfirmed) {
        return;
      }
      const authDetails = localStorageService.getProjectDetails();
      const projectName = JSON.parse(authDetails).projectName;
      apiService
        .updateDoiFlagStatusForManuscripts(
          dioFlagStatusVlaue,
          action,
          projectName
        )
        .then((response) => {
          if(response.data.data !== 0){
          toast.success(
            response.data.data + " record " + response.data.message,
            2000
          );
        }else{
          toast.info(`${dioFlagStatusVlaue} is already in unresolved state..!!`, 2000);
        }
          setDioFlagStatusVlaue("");
          resetForm();
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
    }
  };

  useEffect(() => {
    if (project !== "" && selectedDoiFilter !== "") {
      const authDetails = localStorageService.getProjectDetails();
      const projectName = JSON.parse(authDetails).projectName;
      apiService
        .getDoiReport(selectedDoiFilter, projectName)
        .then((response) => {
          setDoiFilterReport(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
    }
  }, [selectedDoiFilter]);

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(doiFilterRepoort);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DOI_Report");
    XLSX.writeFile(workbook, "doi_report.xlsx");
  };

  const downloadExcelJournalReport = () => {
    const worksheet = XLSX.utils.json_to_sheet(JournalReport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Journal_Report");
    XLSX.writeFile(workbook, "Journal_Report.xlsx");
  };

  useEffect(() => {
    if (project !== "" && selectedJournalFilters !== "") {
      const authDetails = localStorageService.getProjectDetails();
      const projectName = JSON.parse(authDetails).projectName;

      setIsJournalReportLoading(true);

      apiService
        .getJournalReport(selectedJournalFilters, projectName)
        .then((response) => {
          const data = response.data?.data || [];
          settJournalReport(data);
          setJournalReportCount(data.length);
          alert(`Total ${data.length} items Found`);
          // setselectedJournalFilters("");
        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message || "Error fetching report",
            { autoClose: 3000 }
          );
        })
        .finally(() => {
          setIsJournalReportLoading(false);
        });
    }
  }, [selectedJournalFilters]);

  return (
    // <div className="card vh-100">
    <div className="container-fluid ">
      <h3 className="text-center">Update Manuscript Status</h3>
      {/* <div className="d-flex justify-content-center form-group mb-3 text-start p-5  border border-1"> */}
      <label htmlFor="project" className="form-label me-5 align-middle ">
        Project
      </label>
      <select
        className="form-select form-select-sm"
        id="project"
        name="project"
        style={{ width: "300px" }}
        onChange={handleProjectChange}
      >
        <option selected value={""}>
          Choose Project..
        </option>

        {projects &&
          projects.map((project) => (
            <option
              value={project.projectId}
              className="bg-gray-100 hover:bg-gray-200"
              key={project.projectId}
            >
              {project.projectName}
            </option>
          ))}
      </select>
      {/* </div> */}

      {project && (
        <div className="pt-3 card mt-4">
          <div className="card-body">
            <h4>Update Manuscript Status</h4>
            <form className="row g-3">
              <div className="row d-flex ">
                <div className="col-md-8">
                  <div className="row mt-4">
                    <label htmlFor="curator" className="form-label col-md-6">
                      Author Status Flag
                    </label>

                    <div className="col-md-6 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        Status
                      </label>
                      <select
                        id="statusFlag"
                        className="form-select"
                        value={formData.statusFlag}
                        name="statusFlag"
                        onChange={handleChange}
                      >
                        <option value={""}>Choose Author Status...</option>
                        <option value={"Found"}>{"FOUND"}</option>
                        <option value={"Not Found"}>{"NOT FOUND"}</option>
                      </select>
                    </div>

                    {/* <div className="col-md-4 d-flex justify-content-end">
                        <input type="button" className="btn btn-outline-info me-2" value={"Unresolve"} 
                        onClick={()=>{handlesubmit("statusFlag","unresolved")}}/>
                        <input type="button" className="btn btn-outline-warning" value={"Revert Back"}
                        onClick={()=>{handlesubmit("statusFlag","")}}/>
                    </div> */}
                  </div>

                  <div className="row mt-3">
                    <label htmlFor="curator" className="form-label col-md-6">
                      Date Validity Flag
                    </label>

                    <div className="col-md-6 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        Validity
                      </label>
                      <select
                        id="validityFlag"
                        className="form-select"
                        value={formData.validityFlag}
                        name="validityFlag"
                        onChange={handleChange}
                      >
                        <option value={""}>Choose Validity Status...</option>
                        <option value={"VALID_DATE_DIFF"}>
                          {"VALID DATE DIFF"}
                        </option>
                        <option value={"INVALID_DATE_DIFF"}>
                          {"INVALID DATE DIFF"}
                        </option>
                      </select>
                    </div>

                    {/* <div className="col-md-4 d-flex justify-content-end">
                        <input type="button" className="btn btn-outline-info me-2" value={"Unresolve"} 
                        onClick={()=>{handlesubmit("validityFlag","unresolved")}}/>
                        <input type="button" className="btn btn-outline-warning" value={"Revert Back"}
                        onClick={()=>{handlesubmit("validityFlag","")}}/>
                    </div> */}
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-end pt-5 pb-5">
                  <input
                    type="button"
                    className="btn btn-outline-info me-2"
                    value={"Unresolve"}
                    onClick={() => {
                      handlesubmit("authorAndDateFlag", "unresolved");
                    }}
                  />
                  <input
                    type="button"
                    className="btn btn-outline-warning"
                    value={"Revert Back"}
                    onClick={() => {
                      handlesubmit("authorAndDateFlag", "");
                    }}
                  />
                </div>
              </div>
              {/* <hr/> */}

              <div className="row d-flex mb-0">
                <div className="col-md-8">
                  <div className="row mt-4">
                    <label htmlFor="curator" className="form-label col-md-6">
                      LLM Title Score
                    </label>

                    <div className="col-md-3 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        From
                      </label>
                      {/* <input
                        type="number"
                        className="form-control"
                        placeholder="from"
                        min={0}
                        max={100}
                        id="titleScoreFromRange"
                        name="titleScoreFromRange"
                        value={formData.titleScoreFromRange}
                        onChange={handleRowChange}
                      /> */}
                      <select
                        className="form-control"
                        id="titleScoreFromRange"
                        name="titleScoreFromRange"
                        value={formData.titleScoreFromRange}
                        onChange={handleRowChange}
                      >
                        <option>--Select--</option>
                        {llmTitleScores.length > 0 &&
                          llmTitleScores.map((score) => (
                            <option value={score}>{score}</option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        To
                      </label>
                      {/* <input
                        type="number"
                        className="form-control"
                        placeholder="to"
                        min={0}
                        max={100}
                        id="titleScoreToRange"
                        name="titleScoreToRange"
                        value={formData.titleScoreToRange}
                        onChange={handleRowChange}
                      /> */}

                      <select
                        className="form-control"
                        id="titleScoreToRange"
                        name="titleScoreToRange"
                        value={formData.titleScoreToRange}
                        onChange={handleRowChange}
                      >
                        <option>--Select--</option>
                        {llmTitleScores.length > 0 &&
                          llmTitleScores.map((score) => (
                            <option value={score}>{score}</option>
                          ))}
                      </select>
                    </div>
                    {/* <div className="col-md-4 d-flex justify-content-end">
                        <input type="button" className="btn btn-outline-info me-2" value={"Unresolve"} 
                        onClick={()=>{handlesubmit("titleAndAuthorScore","unresolved")}}/>
                        <input type="button" className="btn btn-outline-warning" value={"Revert Back"}
                        onClick={()=>{handlesubmit("titleAndAuthorScore","")}}/>
                    </div> */}
                  </div>
                  <div className="row mt-3">
                    <label htmlFor="curator" className="form-label col-md-6">
                      LLM Author Score
                    </label>

                    <div className="col-md-3 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        From
                      </label>
                      {/* <input
                        type="number"
                        className="form-control"
                        placeholder="from"
                        min={0}
                        max={100}
                        id="authorScoreFromRange"
                        name="authorScoreFromRange"
                        value={formData.authorScoreFromRange}
                        onChange={handleRowChange}
                      /> */}

                      <select
                        className="form-control"
                        id="authorScoreFromRange"
                        name="authorScoreFromRange"
                        value={formData.authorScoreFromRange}
                        onChange={handleRowChange}
                      >
                        <option>--Select--</option>
                        {llmAuthorScores.length > 0 &&
                          llmAuthorScores.map((score) => (
                            <option value={score}>{score}</option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3 d-flex align-items-center">
                      <label htmlFor="curator" className="form-label me-2">
                        To
                      </label>
                      {/* <input
                        type="number"
                        className="form-control"
                        placeholder="to"
                        min={0}
                        max={100}
                        id="authorScoreToRange"
                        name="authorScoreToRange"
                        value={formData.authorScoreToRange}
                        onChange={handleRowChange}
                      /> */}

                      <select
                        className="form-control"
                        id="authorScoreToRange"
                        name="authorScoreToRange"
                        value={formData.authorScoreToRange}
                        onChange={handleRowChange}
                      >
                        <option>--Select--</option>
                        {llmAuthorScores.length > 0 &&
                          llmAuthorScores.map((score) => (
                            <option value={score}>{score}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 d-flex justify-content-end pt-5 pb-5">
                  <input
                    type="button"
                    className="btn btn-outline-info me-2"
                    value={"Unresolve"}
                    onClick={() => {
                      handlesubmit("titleAndAuthorScore", "unresolved");
                    }}
                  />
                  <input
                    type="button"
                    className="btn btn-outline-warning"
                    value={"Revert Back"}
                    onClick={() => {
                      handlesubmit("titleAndAuthorScore", "");
                    }}
                  />
                </div>
              </div>
              <div className="row d-flex align-items-start">
                <label htmlFor="curator" className="form-label col-md-3 mt-4">
                  Journal Flag Filters
                </label>

                <div className="col-md-5 d-flex align-items-center mt-2">
                  <Select
                    className="w-100"
                    options={journalFilters}
                    value={journalFilters.find(
                      (option) => option.value === selectedJournalFilters
                    )}
                    onChange={(selectedOption) => {
                      const value = selectedOption ? selectedOption.value : "";
                      setselectedJournalFilters(value);
                      if (!value) {
                        settJournalReport([]);
                      }
                    }}
                    placeholder="Search Journal ..."
                    isClearable
                  />
                </div>

                <div className="col-md-4 d-flex justify-content-end align-items-center mt-2">
                  <button
                    type="button"
                    className="btn btn-outline-success me-2 text-bg-black"
                    onClick={downloadExcelJournalReport}
                    disabled={JournalReport.length === 0}
                  >
                    Download
                  </button>

                  <input
                    type="button"
                    className="btn btn-outline-info me-2"
                    value="Unresolve"
                    onClick={() => handleJournalFlagFilter("unresolved")}
                  />

                  <input
                    type="button"
                    className="btn btn-outline-warning"
                    value="Revert Back"
                    onClick={() => handleJournalFlagFilter("revert")}
                  />
                </div>
              </div>

              <div className="row d-flex mb-0 ">
                <label htmlFor="curator" className="form-label col-md-3 mt-5">
                  DOI Filters
                </label>
                <div className="col-md-5 d-flex align-items-center">
                  <select
                    className="form-select w-100"
                    id="doiFilter"
                    name="doiFilter"
                    style={{ width: "300px" }}
                    onChange={handleDoiFilterChange}
                  >
                    <option value="">Choose DOI Filter..</option>
                    {doiFilters &&
                      doiFilters.map((filter) => (
                        <option key={filter} value={filter}>
                          {filter}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-4 d-flex justify-content-end pt-5 pb-5">
                  {doiFilterRepoort && (
                    <div className="text-end w-75 mx-auto m-lg-1">
                      <button
                        type="button"
                        className="btn btn-outline-success me-2 text-bg-black"
                        onClick={downloadExcel}
                        disabled={doiFilterRepoort.length === 0}
                      >
                        Download
                      </button>
                    </div>
                  )}
                  {/* <input
                    type="button"
                    className="btn btn-outline-info me-2"
                    value={"Unresolve"}
                    onClick={() => {
                      handleJournalFlagFilter("unresolved");
                    }}
                  />
                  <input
                    type="button"
                    className="btn btn-outline-warning"
                    value={"Revert Back"}
                    onClick={() => {
                      handleJournalFlagFilter("revert");
                    }}
                  /> */}
                </div>
              </div>
              <div className="row d-flex mb-0">
                <label htmlFor="curator" className="form-label col-md-3 mt-5">
                  DOI Flag Status
                </label>

                <div className="col-md-5 d-flex align-items-center">
                  <textarea
                    className="w-100 p-2 text-base rounded-2xl border border-gray-300 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
                    rows="3"
                    name="doiFlagStatus"
                    value={dioFlagStatusVlaue}
                    onChange={(e) => setDioFlagStatusVlaue(e.target.value)}
                    placeholder="Eg : 2020-2247@10.1007/s44186-023-00107-7;;2020-2247@10.1001/jamasurg.2021.0031"
                  ></textarea>
                </div>

                <div className="col-md-4 d-flex justify-content-end pt-5 pb-5">
                  <input
                    type="button"
                    className="btn btn-outline-info me-2"
                    value="Unresolve"
                    onClick={() => handleDioFlagStatus("unresolved")}
                  />
                  <input
                    type="button"
                    className="btn btn-outline-warning"
                    value="Revert Back"
                    onClick={() => handleDioFlagStatus("revert")}
                  />
                </div>
              </div>
            </form>
            <div>
              {" "}
              {projectStatusReport.length !== 0 && (
                <div className="border rounded mb-4 mt-2">
                  <div className="pt-2 ms-2">
                    <h4>Project Status</h4>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="">
                        <tr className="bg-primary">
                          {progressReportHeader.map((item, index) => (
                            <th
                              className="col bg-light text-nowrap text-secondary fs-6 fw-medium"
                              key={item}
                            >
                              {item}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {/* {Object.entries(projectStatusReport).map((data, index) => ( */}
                        <tr key={1}>
                          <td className="align-middle">
                            {projectReport.TOTAL_UNIQUE_PROCESSED}
                          </td>
                          <td className="align-middle">
                            {projectReport.TOTAL_FP_SP}
                          </td>
                          <td className="align-middle">
                            {projectReport.TOTAL_UNIQUE_PROCESSED}
                          </td>
                          <td className="align-middle">
                            {projectReport.TOTAL_RESOLVED}
                          </td>
                          <td className="align-middle">
                            {projectReport.TOTAL_UNRESOLVED}
                          </td>
                          <td className="align-middle">
                            {projectReport.TOTAL_UNRESOLVED_UNIQUE}
                          </td>
                          <td className="align-middle">
                            {projectReport.NO_ACTION}
                          </td>
                          <td className="align-middle">
                            {projectReport.NO_ACTION_UNIQUE}
                          </td>
                        </tr>
                        {/* ))} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isJournalReportLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-light bg-opacity-75 d-flex justify-content-center align-items-center"
          style={{ zIndex: 1050 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateManuscriptStatus;
